import { render } from "./TonImageDialog.vue?vue&type=template&id=b5fcbd50&ts=true"
import script from "./TonImageDialog.ts?vue&type=script&lang=ts"
export * from "./TonImageDialog.ts?vue&type=script&lang=ts"

import "./TonImageDialog.vue?vue&type=style&index=0&id=b5fcbd50&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__